import { EntityUIStateModel } from './entity-ui.state';

export namespace EntityUIStateActions {
  export class InitEntityUIState {
    static readonly type = '[UI - Entity] Init Entity UI State';
    constructor(
      public key: string,
      public initial?: Partial<EntityUIStateModel>,
    ) {}
  }

  export class UpdateEntityUIState {
    static readonly type = '[UI - Entity] Update Entity UI State';
    constructor(
      public key: string,
      public payload: Partial<EntityUIStateModel>,
    ) {}
  }

  export class ResetEntityUIState {
    static readonly type = '[UI - Entity] Reset Entity UI State';
    constructor(public key: string) {}
  }
}
